export const CarouselList = [
	{
		src: "./photos/carousel/1.jpg"
	},
	{
		src: "./photos/carousel/2.jpg"
	},
	{
		src: "./photos/carousel/3.jpg"
	},
	{
		src: "./photos/carousel/4.jpg"
	},
	{
		src: "./photos/carousel/5.jpg"
	},
	{
		src: "./photos/carousel/6.jpg"
	},
	{
		src: "./photos/carousel/7.jpg"
	},
	{
		src: "./photos/carousel/8.jpg"
	},
	{
		src: "./photos/carousel/9.jpg"
	}
];

